import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading, canAccessStudio } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center my-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user || user.is_anonymous) return <Navigate to="/admin/login" state={{ from: location.pathname + location.search }} replace />;
  if (!canAccessStudio) return <div className="container py-5" role="alert"><h1>Access unavailable</h1><p>Your account does not currently have access to Door Studio. Contact your account manager.</p><a href="/admin/login">Return to sign in</a></div>;
  return children;
};

export default PrivateRoute;
